import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import { getInlineLoader } from "../../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";
import { IoMdArrowDropright } from "react-icons/io";
import HomeBanner2 from "./Enterprise2";
import ServicesBanner1 from "./EnterpriseServices";
import HomeBanner4 from "./Enterprise4";
import HomeBanner5 from "./Enterprise5"; 

import banner1 from "../../assets/banner1.jpg";

export default function SystemsHero() {
  const { navTo } = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false
    });
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <>
      <section className="systems-hero position-relative overflow-hidden" style={{ 
        height: 'calc(100vh - var(--topBarHeight))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, rgba(15, 15, 35, 0.94) 0%, rgba(5, 5, 10, 0.9) 100%), url(${banner1})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center', 
        backgroundAttachment: 'fixed',
        marginTop: 'var(--topBarHeight)',
        fontFamily: 'Inter'
      }}>
        
        {/* Subtle Animated Background Elements */}
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ 
          zIndex: 0, 
          pointerEvents: 'none',
          backgroundImage: `radial-gradient(circle at 1px 1px, var(--secondaryColor, #f4911e) 0.05, transparent 0)`,
          backgroundSize: '50px 50px',
          opacity: 0.5
        }}></div>
        
        <div className="position-absolute" style={{ 
          top: '20%', right: '15%', width: '400px', height: '400px', 
          background: 'radial-gradient(circle, rgba(244,145,30,0.1) 0%, transparent 70%)', 
          filter: 'blur(80px)', 
          animation: 'float 18s ease-in-out infinite',
          zIndex: 0 
        }}></div>
        
        <div className="position-absolute" style={{ 
          bottom: '15%', left: '10%', width: '350px', height: '350px', 
          background: 'radial-gradient(circle, rgba(255,255,255,0.03) 0%, transparent 70%)', 
          filter: 'blur(70px)', 
          animation: 'float 22s ease-in-out infinite reverse',
          zIndex: 0 
        }}></div>

        {/* Content */}
        <div className="container position-relative" style={{ zIndex: 1, maxWidth: '950px' }}>
          <div className="text-center px-3">
            
            {/* Headline */}
            <h1 className="font-bold mb-4" data-aos="fade-up" data-aos-delay="200" style={{ 
              fontSize: 'clamp(2.8rem, 7vw, 4.2rem)', 
              color: 'var(--text-light, #ffffff)',
              lineHeight: 1.05,
              letterSpacing: '-0.04em',
              fontWeight: '800',
              margin: '0 auto',
              maxWidth: '850px'
            }}>
              Werenium <br/>
              <span style={{ 
                background: 'linear-gradient(135deg, var(--secondaryColor, #f4911e) 0%, #ffbc6d 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Enterprise Solutions</span>
            </h1>

            {/* Subheadline */}
            <p className="mb-5 text-light opacity-75" data-aos="fade-up" data-aos-delay="300" style={{ 
              fontSize: 'clamp(1.1rem, 2vw, 1.3rem)',
              lineHeight: 1.7,
              maxWidth: '620px',
              margin: '0 auto',
              fontWeight: '300'
            }}>
              Architecting high-level <strong className="text-light">BizSuite</strong> ecosystems and integrated SSID frameworks to drive institutional efficiency and global scalability.
            </p>

            {/* CTA Group */}
            <div data-aos="fade-up" data-aos-delay="400" className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
              <button
                className="cta-btn d-inline-flex align-items-center gap-2 px-5 py-3 rounded-1 border-0 fw-bold text-uppercase"
                onClick={() => navTo({ item: "contact_us" })}
                style={{ 
                  background: 'var(--secondaryColor, #f4911e)', 
                  color: '#ffffff',
                  fontSize: '0.85rem',
                  letterSpacing: '1.2px',
                  transition: 'all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)',
                  boxShadow: '0 8px 30px rgba(244,145,30,0.3)',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-4px)';
                  e.target.style.filter = 'brightness(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.filter = 'brightness(1)';
                }}
              >
                Initiate Deployment <IoMdArrowDropright size={22} />
              </button>
            </div>
          </div>
        </div>

        {/* CSS Animations & Utilities */}
        <style>{`
          @keyframes float {
            0%, 100% { transform: translateY(0) translateX(0); }
            50% { transform: translateY(-20px) translateX(10px); }
          }
          
          .cta-btn {
            min-width: 240px;
            justify-content: center;
          }
          
          .cta-btn:active {
            transform: translateY(-1px) !important;
          }
          
          @media (max-width: 768px) {
            .systems-hero {
              background-attachment: scroll !important;
            }
          }
        `}</style>
      </section>
      <HomeBanner2 />
      <ServicesBanner1 />
      <HomeBanner4 />
      <HomeBanner5 />
    </>
  );
}